const FaqData = [
    {
        key: "GENEL",
        title: "GENEL",
        items: [
            {
                key: "1",
                title: "Pembe Panjur nedir?",
                message: "Pembe Panjur; bilimsel karakter analiz testiyle üyelerinin eşleşmesini sağlayan bir platformdur. Üyelerin kişilik ve sosyo-ekonomik özellikler açısından kendilerine en uygun üyelerle tanışmasını sağlamayı amaçlar. Pembe Panjur’ da tanışmak evliliğe ilk adım olarak nitelendirilir. Bu yüzden Pembe Panjur; bilimsel temellere dayanan bir evlilik sitesidir."
            },
            {
                key: "2",
                title: "Sitenizden evlenen çiftler var mı?",
                message: "Pembe Panjur' da tanışan çiftlerimizin hikayeleri <a href='/basari-hikayeleri'>Başarı Hikayeleri</a> sayfasında yayınlanır. Hikayesini ve 3 adet fotoğrafını bizimle paylaşan çiftlerimize çeşitli sürpriz hediyelerimiz mevcut. Hikayelerini paylaşmak isteyen çiftlerimizle birebir iletişime geçip, röportaj şeklinde hikaye hazırlığı yapabildiğimiz gibi; davet eden çiftlerimizin mutluluklarını paylaşmak için nikah/düğün gibi özel günlerine de mutlaka katılım gösteriyoruz.</br>" +
                    "Eğer siz de Pembe Panjur 'da tanışıp evlendiyseniz sizden de haber bekliyoruz."
            },
            {
                key: "3",
                title: "Size nasıl ulaşabilirim?",
                message: `Çağrı merkezimiz haftanın her günü 09:00 – 01:00 saatleri arasında hizmet vermektedir. </br> <a href='tel:08505580808'>Çağrı Merkezi: 08505580808</a> </br> <a href="mailto:bilgi@pembepanjur.com">E-posta: bilgi@pembepanjur.com</a> </br> <a href="https://api.whatsapp.com/send?phone=+905349270000&text=Üyeliğim ile ilgili bir sorunum var!" target="_blank">Whatsapp: 0534 927 00 00</a> </br> üzerinden bizlere <a href="/iletisim">ulaşabilirsiniz.</a>`
            },
        ],
    },
    {
        key: "GİZLİLİK",
        title: "GİZLİLİK",
        items: [
            {
                key: "1",
                title: "Profilim internette görünür mü?",
                message: "Pembe Panjur üye gizliliğine önem verir; bu yüzden Google’da ya da başka bir arama motoru sonuçlarında kesinlikle profiliniz ya da adınız görünmez."
            },
            {
                key: "2",
                title: "Verilerim nasıl korunuyor?",
                message: "Kişisel Verilerin Korunması Kanunu (KVKK) kanunen zorunludur. Bu düzenleme tamamen kişisel bilgilerinizin güvenliği ve korunması içindir. Pembe Panjur KVKK öncesi hayata geçmiş bir uygulama olduğundan kanun gereği eski / yeni tüm kullanıcılarımız bu uygulamaya tabidir. Uygulamamız, sizin bilginiz dahilinde olmadan hiçbir bilgiyi almaz. Sizin uygulamamız ile paylaştığınız tüm verileriniz de Kişisel Verilerin Korunması Kanunu kapsamında güvence altındadır. Her türlü sorunuzu,<a href='mailto:kvk@pembepanjur.com'>kvk@pembepanjur.com</a> üzerinden bizlere iletebilirsiniz."
            },
            {
                key: "3",
                title: "“Gizli Kalsın” seçeneği nedir?",
                message: "Üyelik sırasında yanıtladığınız tüm soruların eşleşmede size katkısı bulunur. Ancak bazı soruların yanıtlarını eğer dilerseniz diğer üyelerin görmemesini sağlayabilirsiniz. Bunun için yapmanız gereken ‘’Gizli kalsın‘’ seçeneğini işaretlemektir. ‘’Gizli kalsın‘’ seçeneğini işaretlediğiniz sorulara verdiğiniz cevaplar profilinizde gösterilmeyecektir."
            },
            {
                key: "4",
                title: "Sisteminize verdiğim kredi kartı numaram başkaları tarafından görüntülenebilir mi?",
                message: "Tarayıcınızın (browser) alt kısmında görmekte olduğunuz anahtar ikonu, o sayfada tarayıcınız vasıtası ile gönderdiğiniz hiçbir bilginin işlem sırasında üçüncü şahıslar tarafından görünemeyeceğini belirtmektedir. 128 bit SSL şifreleme tekniğiyle şifrelenen bilgilerinizin onayı, anlaşmalı kuruluş sanal POS sistemleri üzerinden ilgili banka ile irtibat kurularak alınır. Bilgiler hiçbir şekilde restorana, Yemeksepeti yetkililerine veya üçüncü şahıslara ulaşmaz. Ayrıca bilgileriniz kayıt altına alınmaz."
            },
            {
                key: "5",
                title: "Ön Bilgilendirme Formu ve Mesafeli Satış Sözleşmeme nereden ulaşabilirim?",
                message: "Tabi olunan ürünler/hizmetler kapsamında ön bilgilendirme formunuza ve mesafeli satış sözleşmenize siparişinizi tamamlamadan hemen önce sepetiniz bölümünden veya siparişiniz sonrası size iletilen bilgilendirme epostası aracılığı ile rahatlıkla ulaşabilirsiniz. Bu metinler ile ilgili herhangi bir soru veya talebiniz olması halinde <a href='mailto:bilgi@pembepanjur.com'>bilgi@pembepanjur.com</a> adresi ile iletişime geçebilirsiniz."
            },
            {
                key: "6",
                title: "Kişisel bilgilerim güvende mi?",
                message: "Kişisel verilerinizi 6698 sayılı Kişisel Verilerin Korunması Kanunu ve kişisel verilerin korunmasına ilişkin ikincil mevzuat ile Kişisel Verileri Koruma Kurulu kararlarına (hep birlikte “KVK Mevzuatı“) uygun biçimde işlemekteyiz. Kişisel verilerin işlenmesinde KVK Mevzuatındaki ilkelere uygun davranmakta, kişisel verilerin güvenliğini sağlamak için gerekli tüm teknik ve idari tedbirleri almaktayız.</br>" +
                    "Kişisel verilerinizin korunmasına yönelik aldığımız tedbirler ve kişisel verileri işlerken uyum sağladığımız kurallar hakkında detaylı bilgi için ayrıca <a href='/kisisel-verilerin-korunmasi'>Kişisel Verilerin İşlenmesi ve Korunması Politikamıza</a>; kişisel verilerinizin işlendiği süreçler ve bunlara ilişkin detaylı bilgi için <a href='/aydinlatma-metni'>Müşteri Kişisel Verileri Aydınlatma Metnimize</a> göz atmanızı öneririz.</br>" +
                    "Bununla birlikte, kart bilgileriniz doğrudan, seçeceğiniz ödeme yöntemine göre, MasterCard veya BKM sunucularında güvenli bir şekilde tutulur. Ödeme bilgilerinizin MasterCard tarafından nasıl işlendiği hakkında detaylı bilgi için MasterPass Kullanım Şartlarına göz atmanızı öneririz."
            }
        ],
    },
    {
        key: "ÜYELİK",
        title: "ÜYELİK",
        items: [
            {
                key: "1",
                title: "Nasıl Üye Olunur?",
                message: "Pembe Panjur’un app, masaüstü ve mobil ara yüzlerinden üye olabilirsiniz. ‘E-posta veya Telefon Numara’nızı yazarak ‘Üyelik Sözleşmesini ve Kişisel Veri Kullanımı Şartlarını’ onayladıktan sonra ‘kayıt ol’ butonuna tıkladığınızda kayıt sorularının yer aldığı sayfalar açılır, soruları yanıtladığınızda üye olmuş olursunuz ve size uygun üyeleri sisteme girdikten sonra görmeye başlarsınız."
            },
            {
                key: "2",
                title: "Şifremi unuttum; ne yapmalıyım?",
                message: "<a href='/sifremi-unuttum'>Şifremi unuttum</a> sayfasını kullanarak şifre yenileme için otomatik e-posta göndermemizi sağlayabilirsiniz. Gelen e-postadaki bağlantıya tıkladığınızda yeni şifrenizi oluşturabileceğiniz sayfaya ulaşırsınız.</br>" +
                    "Telefon numaranız ile kayıt oluşturduysanız sms ile şifrenizi güncelleyebilirsiniz."
            },{
                key: "3",
                title: "Yeni kayıt oldum, hiç kimseyle eşleşmedim. Sorun nedir?",
                message: "Kayıt olduktan birkaç dakika sonra eşleştiğiniz üyelerin profilleri gözükecektir. Eğer yine de eşleştiğiniz üye sayısı çok az gözüküyorsa müşteri hizmetlerimizle <a href='/iletisim'>iletişime</a> geçebilirsiniz."
            },
            {
                key: "4",
                title: "Neden bütün üyeler arasında arama yapamıyorum?",
                message: "Pembe Panjur' da gizliliğiniz önemlidir; dolayısıyla bütün üyeler içinde arama yapmak mümkün değildir. Örneğin Antalya'dan kayıt olan bir üyemiz 100 km mesafede üyelerle eşleşmek istediğini belirtmiş ve profilini sadece uygun üyelere görünür yapmışsa, İstanbul'dan kayıt olan bir diğer üyemiz kendisini arama sonuçlarında göremeyecektir.</br>" +
                    "Size uygun üyeler kayıt aşamasında verdiğiniz cevaplara göre sistem tarafından belirlenecektir. Arama sayfasında yalnızca size uygun üyeler veya profilini görünür yapmayı tercih etmiş üyeler içinde arama yapabilirsiniz. Hangi türde arama yapacağınızı \"Arama\" sayfasında belirtmeniz mümkündür."
            },{
                key: "5",
                title: "Profilimi kimler görebiliyor?",
                message: "Üyeliğinizi oluştururken profilinizi sadece eşleştiğiniz üyelerin görmesini istediğinizi belirttiğinizde profiliniz sadece \"Size uygun üyeler” tarafından görüntülenebilir. Arama sonuçlarında karşı tarafın seçmiş olduğu kriterlere uygun olsa dahi “sadece eşleştiğiniz üyeler” seçtiyseniz profiliniz arama sonuçlarında görünmez.</br>" +
                    "Profilinizin görünürlük ayarını \"Hesap\" sayfasından her zaman güncelleyebilirsiniz."
            },
            {
                key: "6",
                title: "Benimle iletişim kurmasını istemediğim üyeyi nasıl engelleyebilirim?",
                message: "Sizinle iletişim kurmasını istemediğiniz üyenin profili üzerindeki \"Engelle\" düğmesini tıkladığınızda o üye artık size mesaj gönderemez ya da göz kırpamaz."
            },{
                key: "7",
                title: "Hangi olumsuz durumlarda bir üyeyi şikayet etmeliyim?",
                message: "Pembe Panjur ’da hoşunuza gitmeyen bir durumla karşılaştığınızda her zaman müşteri hizmetleriyle <a href='/iletisim'>iletişime</a> geçebilirsiniz. Ancak özellikle aşağıdaki durumlarda mutlaka bize bilgi vermenizi rica ederiz:</br>" +
                    "Evli olduğunu düşündüğünüz üyeler,</br>" +
                    "Gönderdiği mesajın içeriği genel ahlak kuralları dışında olan üyeler,</br>" +
                    "Reklam içerikli mesaj gönderenler,</br>" +
                    "Sizden maddi talepte bulunan üyeler,</br>" +
                    "Profilinde kendine ait olmayan fotoğrafları kullananlar.</br>" +
                    "Bu tür üyelerle karşılaştığınızda öncelikle üyenin profil sayfasındaki \"Şikayet et\" düğmesini kullanıp bize detaylı olarak şikayetinizi iletebilirsiniz. Tüm şikayetler değerlendirilmektedir."
            },
            {
                key: "8",
                title: "Üyeliğimi iptal etmek istiyorum; ne yapmalıyım?",
                message: "Masa üstü kullanıyorsanız Hesap/Görünürlük alanından “Üyelik İptali” yapabilirsiniz.</br>" +
                    "Uygulamalarda ise sağ üstteki üç çizgiyi tıklayarak hesap bölümünden üyelik iptali yapabilirsiniz.</br>" +
                    "Unutmayın, üyelik silmenin geri dönüşü yoktur. Tüm mesajlarınız, göz kırpmalarınız, favorileriniz (yani size dair her şey) silineceği için yeni bir üyelik yaratsanız dahi hiçbirine tekrar ulaşmanız mümkün olmayacaktır."
            },{
                key: "9",
                title: "Gold üyelik nedir?",
                message: "Pembe Panjur’ a üye olmak ücretsizdir. Profili onaylanan her üye standart üye haklarına sahip olur. Bu haklar; ücretsiz profil oluşturmak, profiline fotoğraf eklemek, bilimsel karakter analiz testinden faydalanmak, diğer üyelerin profillerini görüntülemek ve favori seçmekten oluşmaktadır." +
                    "Eğer diğer üyelerle iletişim kurmak, mesaj ve göz kırpma göndermek, durum güncellemesi paylaşmak, sohbet uygulamasından faydalanmak isterseniz Gold üye olmanız gerekir."
            },
            {
                key: "10",
                title: "Gönderdiğim mesajlar karşı tarafa ne zaman iletiliyor?",
                message: "Mesajınız karşı tarafa \"Gönder\" düğmesine tıkladığınız anda anında iletilir."
            },{
                key: "11",
                title: "Mesajlaştığım bir üyenin mesajları duruyor ama profilini göremiyorum. Neden?",
                message: "Bu durumda mesajlaştığınız üye Pembe Panjur üyeliğini sonlandırmıştır."
            },
            {
                key: "12",
                title: "Mesajlaştığım bir üyenin mesajları ve profili silinmiş. Neden?",
                message: "Bu durum üyenin profilinin veya gönderdiği mesajların, Pembe Panjur’ un kurallarına uygun bulunmadığı için üyeliğinin silinmiş olduğu anlamına gelebilmektedir."
            },{
                key: "13",
                title: "Yaş değişikliği yapamıyorum.",
                message: "Gün ve ay bilgisini profilinizi düzenleme alanından değiştirebilirsiniz. Yıl bilgisini ise, bir defaya mahsus olmak üzere müşteri hizmetlerini arayarak güncelleyebilirsiniz."
            },
            {
                key: "14",
                title: "Üyelik dondurma var mı?",
                message: "Sistemde üyelik dondurmak mümkün olmamaktadır. Üyeliğiniz silindiğinde gold üyeliğiniz de sonlanmaktadır. Silinen üyeliklerin tekrar açılması mümkün olmamaktadır."
            },{
                key: "15",
                title: "Çevrimdışı gözükmek istiyorum mümkün mü?",
                message: "Kullanıcıların sistemdeyken çevrimdışı görünmesi mümkün olmamaktadır."
            },
            {
                key: "16",
                title: "Engellediğim kişi profilimi görsün istemiyorum.",
                message: "Engellemiş olduğunuz kullanıcılar profilinizi görüntüleyebilirler ancak sizinle iletişime geçemezler."
            },{
                key: "17",
                title: "Mesajlar nasıl silinir?",
                message: "Silmek istediğiniz mesajı öncelikle arşivlemeniz gerekmektedir. Daha sonra arşivlenen mesajlar bölümüne gelerek istediğiniz mesajı silebilirsiniz. Sistemde toplu mesaj silme işlemi yapılamamaktadır."
            },
            {
                key: "18",
                title: "Din/Mezhep,Sağlık/Engel bilgisi neden görünmez?",
                message: "Kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, ve diğer verileri (maaş,boy,kilo)  özel nitelikli kişisel veridir. KVKK kurallarına göre özel nitelikli kişisel verilerin, ilgilinin açık rızası olmaksızın işlenmesi yasaktır."
            },{
                key: "19",
                title: "Doğrulamasını yaptığım telefon numaram ve sosyal medya hesaplarımı diğer profiller görebiliyor mu?",
                message: "Üyeler birbirlerinin iletişim bilgisini veya sosyal medya hesaplarını görememektedirler. Sosyal medya bilgilerinizi seçmeniz gerçek bir profil olduğunuz anlamına gelir."
            },
            {
                key: "20",
                title: "Profilimi favorisine alanlara müdahale edebilir miyim?",
                message: "Favori listesi kişiye özel olup, kontrolü favori seçen kullanıcıya aittir."
            },
            {
                key: "21",
                title: "Telefon bildirimleri ",
                message: "Telefonunuzun bildirim ayarlarından uygulamamızdan gelecek olan bildirimleri açık veya kapalı hale getirebilirsiniz. Kayıtlı e-posta adresinizin bildirim ayarlarını açmak veya kapatmak için ise profil düzenle /  bildirim ayarları sekmesinden değiştirebilirsiniz."
            },
            {
                key: "22",
                title: "Uygulamadan kullanıyorum fotoğraf ekleyemiyorum ",
                message: "Telefonunuzun bildirim ayarlarından uygulamamızın fotoğraf galerinize erişmesine izin vermeniz gerekmektedir."
            },
            {
                key: "23",
                title: "Profiliniz engellenmiştir uyarısı aldığımda ne yapmalıyım?",
                message: "Profiliniz bloke edildiğinde Müşteri Hizmetlerimiz ile irtibata geçmeniz gerekmektedir."
            },
            {
                key: "24",
                title: "Yurt dışında yaşıyorum nasıl ödeme yapabilirim?",
                message: "Yurt dışında yaşayan üyelerimiz masaüstü bir bilgisayardan profillerine giriş yaparak kredi kartıyla ödeme yapabilir veya TR’de yaşayan bir yakını Pembe Panjur’ un banka hesaplarından birine havale ya da eft yapabilir."
            },
            {
                key: "25",
                title: "Üyeliğim silindiğinde fotoğraflarım görünür mü ?",
                message: "Üyelik silindiğinde profilinizdeki fotoğraflarınız da silinmektedir."
            },
            {
                key: "26",
                title: "Giriş yapamıyorum?",
                message: "Anasayfamızda <a href='/giris'>giriş</a> yaptığınızda karşınıza iki  tane boş  alan gelecektir.</br>" +
                    "Üst kısımdaki alana üyeliğinize ilk aşama oluşturduğunuz “e-posta adresinizi” veya “telefon numaranızı” yazarak;</br>" +
                    "Alt kısımdaki alana  şifrenizi yazdıktan sonra “üye girişi” yazan butona tıkladığınızda üyeliğinize giriş yapmış olacaksınız.</br>" +
                    "“Kayıt ol “butonu sadece yeni üye olacak kişiler için geçerlidir."
            },
            {
                key: "27",
                title: "Eski üyeliğimi aktif hale getirebilir miyim?",
                message: "Silinen üyelikler tekrar geri aktif edilememektedir."
            },
        ],
    },
    {
        key: "ÖDEME",
        title: "ÖDEME",
        items: [
            {
                key: "1",
                title: "Havale/EFT ile ödeme yaptım ama Gold üyeliğim başlamadı. Neden?",
                message: "Garanti Bankası/ İş Bankası ve PTT üzerinden ödemenizi gerçekleştirebilirsiniz.</br>" +
                    "Havale/eft/fast ödemelerinizde mutlaka üye numaranızı açıklama bölümüne yazmanız gerekmektedir.</br>" +
                    "Atm’den yapılan ödemelerde üye numarası yazılamamaktadır, bu durumda çağrı merkezimizi aradığınızda üye numaranızı ve ödeme bilgilerinizi söylemeniz durumunda tanımlama gerçekleştirilecektir.</br>" +
                    "Üye numaranızı “Hesap” bölümünden görüntüleyebilirsiniz.</br>" +
                    "Garanti Bankası ve İş Bankası’ndan yapılan ödeme bildirimleri en geç bir sonraki iş günü tarafımıza ulaşmaktadır.</br>" +
                    "Ptt ödemelerinde ise çağrı merkezimizi arayarak bilgilendirmeniz gerekmektedir."
            },
            {
                key: "2",
                title: "Mobil ödemeyi cep telefonu hattı olan herkes kullanabiliyor mu?",
                message: "Mobil ödeme ile Turkcell, Vodafone ve Türk Telekom aboneleri ödeme yapabilmektedir. Mobil ödeme yapabilme özelliği Operatör tarafından kullanıma açılmaktadır. Ödeme için genel operatör koşulları şunlardır;</br>" +
                    "Hattınız faturalı ise son 3 faturanızı düzenli ödemiş olmanız gerekir.</br>" +
                    "Hattınız faturasız ise ödeme yapmaya yetecek kadar bakiyenizin olması gerekir.</br>" +
                    "Aynı ay içerisinde Mobil Ödeme ile birden fazla kez ödeme yaptıysanız; Turkcell, Vodafone ve Türk Telekom’ un  belirlediği aylık Mobil Ödeme limitini geçmemiş olmanız gerekir."
            },{
                key: "3",
                title: "Mobil ödeme yapınca faturama nasıl yansıyacak?",
                message: "Mobil ödeme Turkcell, Vodafone ve Türk Telekom tarafından verilen bir hizmettir. Hattınız faturasız ise Gold üyelik ücreti bakiyenizden anında düşülür. Hattınız faturalı ise dönem sonunda gelen faturanıza \"Mobil Ödeme\" olarak yansır."
            },
            {
                key: "4",
                title: "Mobil ödemeyle ödeme yaptığımda Gold üyeliğim ne zaman başlar?",
                message: "İşlem otomatik olarak gerçekleşir ve hemen Gold üyeliğinizi kullanmaya başlayabilirsiniz. Operatörünüze SMS' inizin ulaşmasında gecikme olması durumunda da en geç birkaç dakika içinde hesabınızda Gold üyeliğiniz aktif olacaktır."
            },{
                key: "5",
                title: "Mobil ödemeyle ilgili sorunlar yaşıyorum, ne yapabilirim?",
                message: "Mobil ödeme servisiyle ilgili yaşadığınız sorunlar için kullandığınız Operatörle iletişime geçebilirsiniz. </br>" +
                    "Turkcell' in mobil ödeme servisiyle ilgili bilgiler için <a href='https://www.turkcell.com.tr/servisler' target='blank'> bu adresi</a>,</br>" +
                    "Türk Telekom'un mobil ödeme servisiyle ilgili bilgiler için <a href='https://bireysel.turktelekom.com.tr/dijital-servisler/tt-mobil-odeme' target='blank'> bu adresi</a>,</br>" +
                    "Vodafone' nun mobil ödeme servisiyle ilgili bilgiler için <a href='https://www.vodafone.com.tr/servisler/mobil-odeme' target='blank'> bu adresi</a>, ziyaret edebilirsiniz."
            },
            {
                key: "6",
                title: "Mobil ödeme veya kredi kartı ile ödeme  yaptığımda da ödeme tekrarı olur mu?",
                message: "Kredi kartı ile ödemede olduğu gibi, Mobil ödemede de Gold üyeliğiniz ödeme tekrarınız açık olduğu sürece yenilenir. Yenilenen Gold üyelik ücreti, yine cep telefonu faturanıza yansıyacak veya toplam bakiyenizden düşülecektir. Ödeme tekrarını istediğiniz zaman \"Hesap\" sayfasından kapatabilirsiniz."
            },{
                key: "7",
                title: "Ama ben kredi kartımı vermek istemiyorum?",
                message: "Google play ve itunes hesabınızda hangi kart bilginiz tanımlıysa onunla ödeme yapabilirsiniz, kredi kartını seçeneklerden çıkardığınızda ise Havale/eft’yle veya bir aylık üyelik için mobil ödeme yöntemiyle de ödeme yapabilirsiniz."
            },
            {
                key: "8",
                title: "Ücret İadesi Koşulları Nedir?",
                message: "Ücret iadesi yapılabilmesi için;</br>" +
                    "İade talebinin ücret ödemesinden sonraki 7 gün içinde talep edilmesi gerekir.</br>" +
                    "Kredi kartı, cep telefonu ya da Google Play üzerinden ile aylık 3 aylık, 6 aylık abone olan üyelerden aylık üyelik satın alanlar 7 (yedi),</br>" +
                    "3 ve 6 aylık üyelik satın alanlar 15 (on beş) gün içerisinde profillerinde bulunan \"hesap\" sayfasından ya da çağrı merkezini arayarak otomatik ödemelerini kapatıp iade talebinde bulunabilirler.</br>" +
                    "Itunes ya da Google Play üzerinden üyelik satın alan Kullanıcıların telefonlarındaki ayarlar bölümünden otomatik ödemeyi kapatması gerekmektedir."
            }
        ],
    },
    // {
    //     key: "Ödeme",
    //     title: "Ödeme",
    //     items: [
    //         {
    //             key: "1",
    //             title: "",
    //             message: ""
    //         },
    //         {
    //             key: "2",
    //             title: "",
    //             message: ""
    //         }
    //     ],
    // },
];

export default FaqData;
